import React from "react"

import classNames from "classnames"

import "./styles/_hamburger.scss"

interface HamburgerProps {
  isOpen: boolean
}

export const Hamburger = React.memo(({ isOpen }: HamburgerProps) => {
  return (
    <div className="hamburger">
      <div className={classNames("hamburger-inner", { "active-menu": isOpen })}>
        <a
          className={classNames("main-nav-toggle", {
            "active-menu": isOpen
          })}
        >
          <i />
        </a>
      </div>
    </div>
  )
})
